import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">精彩视频</h2>
          <p className="text-foreground-600 text-sm md:text-base">热门视频内容精选</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((media) => (
            <div
              key={media.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={media.cover}
                  alt={media.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold">
                    {media.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all group-hover:scale-110">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-black/60 text-white text-xs">{media.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {media.title}
                </h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {media.views} 次播放
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}